import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgModel, NgForm } from '@angular/forms';
import { AuthService } from '@shared/auth.service';
import { ChangePassword } from './change-password.model';
import { UserService } from './change-password.service';
import { EncryptionProviderService } from '@shared/encryption.service';
import { Something_went_wrong } from '@root/app.constant'; 


@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  providers: [UserService],
})
export class ChangePasswordComponent implements OnInit {

  @ViewChild('f', { static: false })

  form: NgForm;

  oldPassword: string;

  newPassword: string;

  confirmNewPassword: string;

  constructor(
    private toastr: ToastrService,
    public authService: AuthService,
    public userService: UserService,
    public encryptionProviderService: EncryptionProviderService
  ) {}

  ngOnInit() {
  }

  public processForm() {
    const userInfo = AuthService.userInfo();
    const obj: ChangePassword = {
      userId: userInfo.userId,
      password: this.encryptionProviderService.encryptData(this.oldPassword),
      newPassword: this.encryptionProviderService.encryptData(
        this.confirmNewPassword
      ),
    };
    this.userService.userPasswordChange(obj).subscribe(
      (response) => {
        if (response.status === 0) {
          this.toastr.success(response.message);
          this.resetForm();
        } else {
          if (response.error.errorMessage === null) {
            this.toastr.error(Something_went_wrong);
          } else {
            this.toastr.error(response.error.errorMessage);
          }
        }
      },
      (error) => {
        this.toastr.error(error.error.errorMessage);
      }
    );
  }

  public onChangeConfirmPassword(value: string) {
    this.confirmNewPassword = value;
    if (
      value &&
      this.newPassword &&
      value !== this.newPassword &&
      this.form.controls.confirmnewpwd
    ) {
      this.form.controls.confirmnewpwd.setErrors({
        passwordDonotMatch: { valid: false },
      });
    }
  }

  public resetForm() {
    if (this.form) {
      this.form.resetForm();
    }
  }
}
